module.exports = __webpack_public_path__ + "static/media/background.6ad6d42b.png";